import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-administration-component',
  templateUrl: './administration.component.html'
})
export class AdministrationComponent {

  @ViewChild(RouterOutlet) outlet: RouterOutlet;

}
